const BONUS_LABEL_MAPPING = {
  AnnouncementDate: 'Announcement Date',
  BonusDate: 'Bonus Date',
  BonusRatio: 'Ratio',
};

const SPLITS_LABEL_MAPPING = {
  SplitDate: 'Split Date',
  FVBefore: 'Before FV',
  FVAfter: 'After FV',
  SplitRatio: 'Ratio',
};

const RIGHTS_LABEL_MAPPING = {
  RightDate: 'Ex - Right',
  premium: 'Premium',
  RightsRatio: 'Ratio',
};

const LABEL_MAPPINGS = {
  BONUS: BONUS_LABEL_MAPPING,
  SPLITS: SPLITS_LABEL_MAPPING,
  RIGHTS: RIGHTS_LABEL_MAPPING,
};

function setCookie(name, value, days = 1) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
  window.location.reload(true);
}

function formatDateString(dateStr) {
  const date = new Date(dateStr);
  if (!isNaN(date)) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }
  return dateStr;
}

const updateStockExchange = async (exchange, companyName) => {
  setCookie(`stk-${companyName}-currentExchange`, exchange);
};

function mapKeys(data, mapping_obj) {
  const abc = Object.fromEntries(
    Object.entries(data)
      .filter(([key]) => Object.prototype.hasOwnProperty.call(mapping_obj, key))
      .map(([key, value]) => [
        mapping_obj[key] || key,
        typeof value === 'string' && !isNaN(Date.parse(value))
          ? formatDateString(value)
          : value,
      ]),
  );
  return abc;
}

function init() {
  const nseButtons = document.querySelectorAll('.nse-btn');
  const bseButtons = document.querySelectorAll('.bse-btn');
  nseButtons.forEach((btn) => {
    btn.addEventListener('click', async () => {
      const companyName = btn.getAttribute('data-companyName');
      updateStockExchange('nse', companyName);
    });
  });
  bseButtons.forEach((btn) => {
    btn.addEventListener('click', async () => {
      const companyName = btn.getAttribute('data-companyName');
      updateStockExchange('bse', companyName);
    });
  });
  const tabs = document.querySelectorAll('.tab');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
    });
  });

  const elements = {
    conditiontoggleThumb: document.querySelector('.condition-toggle-thumb'),
    periodtoggleThumb: document.querySelector('.period-toggle-thumb'),
    standaloneText: document.getElementById('financial-type-standalone'),
    consolidatedText: document.getElementById('financial-type-consolidated'),
    yearlyText: document.getElementById('financial-type-yearly'),
    quarterlyText: document.getElementById('financial-type-quarterly'),
    standaloneTable: document.querySelector('.table-container-standalone'),
    consolidatedTable: document.querySelector('.table-container-consolidated'),
    standaloneQuarterlyTable: document.querySelector(
      '.table-container-standalone-quarterly',
    ),
    consolidatedQuarterlyTable: document.querySelector(
      '.table-container-consolidated-quarterly',
    ),
  };
  function updateTextState(isConsolidated, isYearly) {
    elements.consolidatedText.classList.toggle(
      'non-selected-color',
      !isConsolidated,
    );
    elements.standaloneText.classList.toggle(
      'non-selected-color',
      isConsolidated,
    );
    elements.yearlyText.classList.toggle('non-selected-color', !isYearly);
    elements.quarterlyText.classList.toggle('non-selected-color', isYearly);
  }
  function updateTableState(isConsolidated, isYearly) {
    const activeTable = isConsolidated
      ? isYearly
        ? elements.consolidatedTable
        : elements.consolidatedQuarterlyTable
      : isYearly
        ? elements.standaloneTable
        : elements.standaloneQuarterlyTable;
    [
      elements.standaloneTable,
      elements.consolidatedTable,
      elements.standaloneQuarterlyTable,
      elements.consolidatedQuarterlyTable,
    ].forEach((table) => {
      table.classList.remove('active');
    });
    activeTable.classList.add('active');
  }
  function updateTables() {
    const isConsolidated =
      elements.conditiontoggleThumb.classList.contains('toggle-thumb-left');
    const isYearly = elements.periodtoggleThumb.classList.contains(
      'toggle-period-thumb-left',
    );
    updateTextState(isConsolidated, isYearly);
    updateTableState(isConsolidated, isYearly);
  }
  document
    .querySelector('.condition-toggle-track')
    .addEventListener('click', () => {
      if (
        elements.conditiontoggleThumb.classList.contains('toggle-thumb-left')
      ) {
        elements.conditiontoggleThumb.classList.remove('toggle-thumb-left');
        elements.conditiontoggleThumb.classList.add('toggle-thumb-right');
      } else {
        elements.conditiontoggleThumb.classList.remove('toggle-thumb-right');
        elements.conditiontoggleThumb.classList.add('toggle-thumb-left');
      }
      updateTables();
    });
  document
    .querySelector('.period-toggle-track')
    .addEventListener('click', () => {
      if (
        elements.periodtoggleThumb.classList.contains(
          'toggle-period-thumb-left',
        )
      ) {
        elements.periodtoggleThumb.classList.remove('toggle-period-thumb-left');
        elements.periodtoggleThumb.classList.add('toggle-period-thumb-right');
      } else {
        elements.periodtoggleThumb.classList.remove(
          'toggle-period-thumb-right',
        );
        elements.periodtoggleThumb.classList.add('toggle-period-thumb-left');
      }
      updateTables();
    });
  updateTables();
}

const render_corporate_card = async (
  containerEl,
  errorEl,
  tabValue,
  company_code,
) => {
  let corporateActionsData = {};
  let mappedCorporateActionsData = {};
  while (containerEl.firstChild) {
    containerEl.removeChild(containerEl.firstChild);
  }
  const corporateCardEls = document.querySelectorAll('.card-container');
  corporateCardEls.forEach((corporateCardEl) => {
    corporateCardEl.style.display = 'none';
  });

  try {
    const url = `${window._Torus.BFF_BASE_URL}/corporate-actions/${tabValue}/${company_code}`;
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch ${tabValue} data`);
    }
    try {
      corporateActionsData = await response.json();
    } catch (jsonError) {
      throw new Error('JSON Parsing Error');
    }
    if (
      !corporateActionsData ||
      Object.keys(corporateActionsData).length === 0
    ) {
      throw new Error('Empty response data');
    }
    mappedCorporateActionsData = mapKeys(
      corporateActionsData,
      LABEL_MAPPINGS[tabValue.toUpperCase()],
    );
    containerEl.style.display = 'block';
    const infoContainer = document.createElement('div');
    infoContainer.classList.add('info-container');
    Object.entries(mappedCorporateActionsData).forEach(([key, value]) => {
      const infoGroup = document.createElement('div');
      infoGroup.classList.add('info-group');
      const labelElement = document.createElement('span');
      labelElement.classList.add('label');
      labelElement.textContent = key;
      const dataElement = document.createElement('span');
      dataElement.classList.add('data');
      dataElement.textContent = value;
      infoGroup.appendChild(labelElement);
      infoGroup.appendChild(dataElement);
      infoContainer.appendChild(infoGroup);
    });
    containerEl.appendChild(infoContainer);
    containerEl.style.display = 'block';
  } catch (error) {
    errorEl.style.display = 'block';
    containerEl.style.display = 'none';
  }
};

document.getElementById('dividend').addEventListener('click', function () {
  const corporateCardEls = document.querySelectorAll('.card-container');
  corporateCardEls.forEach((corporateCardEl) => {
    corporateCardEl.style.display = 'none';
  });
  const errorBoxEls = document.querySelectorAll('.corporate-empty-box');
  errorBoxEls.forEach((errorBoxEl) => {
    errorBoxEl.style.display = 'none';
  });
  const dividendErrorBox = document.getElementById('dividend-empty-box');
  if (dividendErrorBox) {
    dividendErrorBox.style.display = 'block';
  } else {
    const divdendContainer = document.getElementById('divident-container');
    divdendContainer.style.display = 'block';
  }
  const corporateTabs = document.querySelectorAll('.corporate-tab');
  corporateTabs.forEach((corporateTab) => {
    corporateTab.classList.remove('selected-tab');
  });
  document.getElementById('dividend').classList.add('selected-tab');
});

document.getElementById('bonus').addEventListener('click', function () {
  const errorBoxEls = document.querySelectorAll('.corporate-empty-box');
  errorBoxEls.forEach((errorBoxEl) => {
    errorBoxEl.style.display = 'none';
  });
  const corporateTabs = document.querySelectorAll('.corporate-tab');
  corporateTabs.forEach((corporateTab) => {
    corporateTab.classList.remove('selected-tab');
  });
  document.getElementById('bonus').classList.add('selected-tab');
  const containerEl = document.getElementById('bonus-container');
  const company_code = containerEl.getAttribute('data-cocode');
  const errorEl = document.getElementById('bonus-empty-box');
  render_corporate_card(containerEl, errorEl, 'bonus', company_code);
});

document.getElementById('splits').addEventListener('click', function () {
  const errorBoxEls = document.querySelectorAll('.corporate-empty-box');
  errorBoxEls.forEach((errorBoxEl) => {
    errorBoxEl.style.display = 'none';
  });
  const corporateTabs = document.querySelectorAll('.corporate-tab');
  corporateTabs.forEach((corporateTab) => {
    corporateTab.classList.remove('selected-tab');
  });
  document.getElementById('splits').classList.add('selected-tab');
  const containerEl = document.getElementById('splits-container');
  containerEl.style.display = 'block';
  const company_code = containerEl.getAttribute('data-cocode');
  const errorEl = document.getElementById('splits-empty-box');
  render_corporate_card(containerEl, errorEl, 'splits', company_code);
});

document.getElementById('rights').addEventListener('click', function () {
  const errorBoxEls = document.querySelectorAll('.corporate-empty-box');
  errorBoxEls.forEach((errorBoxEl) => {
    errorBoxEl.style.display = 'none';
  });
  const corporateTabs = document.querySelectorAll('.corporate-tab');
  corporateTabs.forEach((corporateTab) => {
    corporateTab.classList.remove('selected-tab');
  });
  document.getElementById('rights').classList.add('selected-tab');
  const containerEl = document.getElementById('rights-container');
  const company_code = containerEl.getAttribute('data-cocode');
  const errorEl = document.getElementById('rights-empty-box');
  render_corporate_card(containerEl, errorEl, 'rights', company_code);
});

document.getElementById('AGM').addEventListener('click', function () {
  const corporateCardEls = document.querySelectorAll('.card-container');
  corporateCardEls.forEach((corporateCardEl) => {
    corporateCardEl.style.display = 'none';
  });
  const errorBoxEls = document.querySelectorAll('.corporate-empty-box');
  errorBoxEls.forEach((errorBoxEl) => {
    errorBoxEl.style.display = 'none';
  });
  const agmErrorBox = document.getElementById('agm-empty-box');
  if (agmErrorBox) {
    agmErrorBox.style.display = 'block';
  } else {
    const agmContainer = document.getElementById('agm-container');
    agmContainer.style.display = 'block';
  }
  const corporateTabs = document.querySelectorAll('.corporate-tab');
  corporateTabs.forEach((corporateTab) => {
    corporateTab.classList.remove('selected-tab');
  });
  document.getElementById('AGM').classList.add('selected-tab');
});

document.getElementById('EGM').addEventListener('click', function () {
  const corporateCardEls = document.querySelectorAll('.card-container');
  corporateCardEls.forEach((corporateCardEl) => {
    corporateCardEl.style.display = 'none';
  });
  const errorBoxEls = document.querySelectorAll('.corporate-empty-box');
  errorBoxEls.forEach((errorBoxEl) => {
    errorBoxEl.style.display = 'none';
  });
  const egmErrorBox = document.getElementById('egm-empty-box');
  if (egmErrorBox) {
    egmErrorBox.style.display = 'block';
  } else {
    const egmContainer = document.getElementById('egm-container');
    egmContainer.style.display = 'block';
  }
  const corporateTabs = document.querySelectorAll('.corporate-tab');
  corporateTabs.forEach((corporateTab) => {
    corporateTab.classList.remove('selected-tab');
  });
  document.getElementById('EGM').classList.add('selected-tab');
});

const readMore = document.querySelector('.read-more');
if (readMore) {
  readMore.addEventListener('click', function () {
    var description = document.querySelector('.description');
    var readMore = document.querySelector('.read-more');
    if (!description.classList.contains('expanded')) {
      description.classList.add('expanded');
      readMore.classList.add('clicked');
      readMore.textContent = 'Click here to know more';
    } else {
      var aboutUsSection = document.getElementById('about-company');
      aboutUsSection.scrollIntoView({ behavior: 'smooth' });
    }
  });
}

const topTab = document.querySelectorAll('.anchors-section .container a');
const sections = document.querySelectorAll('.tab-section');
window.onscroll = () => {
  sections.forEach((sec) => {
    let top = window.scrollY;
    let offset = sec.offsetTop;
    let height = sec.offsetHeight;
    let id = sec.getAttribute('id');
    if (top >= offset && top < offset + height) {
      topTab.forEach((links) => links.classList.remove('active'));
      document
        .querySelector('.anchors-section .container a[href*=' + id + ']')
        .classList.add('active');
    }
  });
};

document.addEventListener('DOMContentLoaded', init());
